"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[DefaultVideoStreamIdSet]] implements [[VideoStreamIdSet]].
 */

var DefaultVideoStreamIdSet = /*#__PURE__*/function () {
  function DefaultVideoStreamIdSet(ids) {
    _classCallCheck(this, DefaultVideoStreamIdSet);

    this.ids = new Set(ids);
  }

  _createClass(DefaultVideoStreamIdSet, [{
    key: "add",
    value: function add(streamId) {
      this.ids.add(streamId);
    }
  }, {
    key: "array",
    value: function array() {
      var values = Array.from(this.ids.values());
      return values.sort(function (a, b) {
        return a - b;
      });
    }
  }, {
    key: "contain",
    value: function contain(streamId) {
      return this.ids.has(streamId);
    }
  }, {
    key: "forEach",
    value: function forEach(callbackFn) {
      this.ids.forEach(callbackFn);
    }
  }, {
    key: "empty",
    value: function empty() {
      return this.ids.size === 0;
    }
  }, {
    key: "size",
    value: function size() {
      return this.ids.size;
    }
  }, {
    key: "equal",
    value: function equal(other) {
      if (!other) {
        return this.ids.size === 0;
      }

      var x = this.array();
      var y = other.array();

      if (x.length !== y.length) {
        return false;
      }

      for (var i = 0; i < x.length; i++) {
        if (x[i] !== y[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new DefaultVideoStreamIdSet(this.array());
    }
  }, {
    key: "remove",
    value: function remove(streamId) {
      this.ids.delete(streamId);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.array();
    }
  }, {
    key: "truncate",
    value: function truncate(length) {
      var x = this.array();
      return new DefaultVideoStreamIdSet(x.splice(0, length));
    }
  }]);

  return DefaultVideoStreamIdSet;
}();

exports.default = DefaultVideoStreamIdSet;